/* eslint-disable jsx-a11y/control-has-associated-label */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as shared from '../assets/shared.module.scss';
import * as classes from './classes.module.scss';

const ColorSelection = ({
  colorName,
  currentColor,
  setColor
}) => {
  const [name, color] = colorName;
  const className = classnames(
    classes.color, { [classes.selectedColor]: color === currentColor }
  );
  const style = {
    backgroundColor: color
  };
  const selectColor = () => setColor(color);
  return (
    <button
      type="button"
      className={ className }
      style={ style }
      onClick={ selectColor }
      key={ color }
      aria-label={ name }
      title={ name }
    >
      &nbsp;
    </button>
  );
};

ColorSelection.propTypes = {
  colorName: PropTypes.array.isRequired,
  currentColor: PropTypes.string.isRequired,
  setColor: PropTypes.func.isRequired
};

const ColorSection = ({
  section, colors, currentColor, setColor
}) => {
  if (!colors.length) {
    return null;
  }
  return (
    <div key={ section }>
      <h4 className={ classnames(shared.h4, shared.balanced) }>
        { section }
      </h4>
      <div className={ classes.section }>
        {
          colors.map((c) => (
            <ColorSelection
              colorName={ c }
              currentColor={ currentColor }
              setColor={ setColor }
              key={ c }
            />
          ))
        }
      </div>
    </div>
  );
};

ColorSection.propTypes = {
  section: PropTypes.string.isRequired,
  colors: PropTypes.array.isRequired,
  currentColor: PropTypes.string.isRequired,
  setColor: PropTypes.func.isRequired
};

const Color = ({ currentColor, defaultColor, setColor }) => (
  <>
    <div>
      <h4 className={ classnames(shared.h4, shared.balanced) }>
        Default
      </h4>
      <div className={ classnames(classes.section, classes.defaultView) }>
        <ColorSelection colorName={ ['Default', defaultColor] } currentColor={ currentColor } setColor={ setColor } />
      </div>
    </div>
    {
      window.colors.map(({ name, colors }) => (
        <ColorSection
          key={ name }
          section={ name }
          colors={ colors }
          currentColor={ currentColor }
          setColor={ setColor }
        />
      ))
    }
  </>
);

Color.propTypes = {
  currentColor: PropTypes.string.isRequired,
  defaultColor: PropTypes.string.isRequired,
  setColor: PropTypes.func.isRequired
};

export default Color;
